import React from "react";

const NotFound = () => {    
  return (
    <div style={{display: "flex", justifyContent: "center", alignItems: "center", height: "100vh"}}>
        <h1>Page Not Found</h1>
    </div>
  );              
};
export default NotFound;